import { SignatureRequest } from '@app/models/documents/signature-request.model';
import { BadgeColumn } from '@app/modules/table/classes/badge-column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';
import { Translatable } from '@app/types/translatable.type';
import { SignatureRequestStatusDisplayOptions } from '@app/types/translatables/document-assign-display.options';
import { format } from 'date-fns';

const creatingStatusBadge: BadgeDisplay = {
    type: 'warning',
    label: SignatureRequestStatusDisplayOptions['creating'],
};

const multiSignerStatusBadge: BadgeDisplay = {
    type: 'warning',
    label: SignatureRequestStatusDisplayOptions['pending'],
};

const singleSignerStatusBadge: BadgeDisplay = {
    type: 'warning',
    label: SignatureRequestStatusDisplayOptions['notSigned'],
};

const blockedStatusBadge: BadgeDisplay = {
    type: 'danger',
    label: SignatureRequestStatusDisplayOptions['blocked'],
};

export class SignatureRequestStatusColumn extends BadgeColumn<SignatureRequest> {
    title = 'document.status';
    property = 'completedAt';
    sortable = true;
    type: CellDisplay = CellDisplay.badge;

    constructor() {
        super();
    }

    getBadgeDisplay(request: SignatureRequest): BadgeDisplay | undefined {
        if (request.isComplete()) {
            return;
        }

        if (request.isCreating()) {
            return creatingStatusBadge;
        }

        const hasTerminatedEmployee =
            request.employee.isTerminated() || request.cosigners.some((s) => s.employee.isTerminated());
        if (hasTerminatedEmployee) {
            return blockedStatusBadge;
        }

        return request.isMultiSigner() ? multiSignerStatusBadge : singleSignerStatusBadge;
    }

    getCellText(signatureRequest: SignatureRequest): Translatable | null {
        return signatureRequest.isComplete()
            ? {
                  key: 'document.signatureRequestStatus.signedOnDate',
                  params: {
                      date: format(signatureRequest.completedAt, 'D MMM YYYY'),
                  },
              }
            : null;
    }
}
